module.exports = __webpack_public_path__ + "img/part5-3.c42c9ef3.png";